import { icons, streamlineIcons } from '@pega/cosmos-react-core';

export const commonIconNames = icons.filter(i =>
  (streamlineIcons as readonly string[]).includes(i)
);
